<template>
  <v-row no-gutters>
    <v-col cols="12">
      <transition-group name="fade-transition">
        <v-card v-for="(invoice, index) in invoices" :key="`invoice_${index}`" class="ma-1" outlined>
          <v-row no-gutters class="pa-1">
            <v-col cols="12" md="11">
              <v-autocomplete v-model="invoice.id" :items="all" class="ma-1" label="Referință" outlined dense hide-details/>
            </v-col>
            <v-col cols="12" md="1">
              <div class="ma-1">
                <v-btn height="40" color="delete white--text" depressed block @click="removeInvoice(invoice)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </transition-group>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn dark color="create" class="ma-1" depressed @click="addInvoice">
        <v-icon left>mdi-plus</v-icon>
        Adaugă
      </v-btn>
    </v-col>
  </v-row>


</template>

<script>
  export default {
    props: {
      all: Array,
      invoices: Array
    },

    methods: {
      addInvoice() {
        this.invoices.push({id: null});
      },

      removeInvoice(invoice) {
        this.invoices.splice(this.invoices.indexOf(invoice), 1);
      },
    }
  }
</script>